"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceRteMentionShortcodes = void 0;
const html_entities_1 = require("html-entities");
const mentionShortcodeRegex = /\[@\s+([^\]]+)\]/g;
const parseShortcodeAttribute = (attrs, name) => {
    var _a;
    const match = attrs.match(new RegExp(`\\b${name}\\s*=\\s*(?:"([^"]*)"|'([^']*)')`));
    const raw = (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : match === null || match === void 0 ? void 0 : match[2];
    if (!raw) {
        return null;
    }
    return (0, html_entities_1.decode)(raw)
        .replace(/\u00a0/g, ' ')
        .trim();
};
// TipTap mention shortcode format used in our markdown variant:
// [@ id="..." label="..."]
const replaceRteMentionShortcodes = (text) => {
    if (!text) {
        return '';
    }
    return text.replace(mentionShortcodeRegex, (match, attrs, offset, input) => {
        var _a;
        const label = parseShortcodeAttribute(attrs, 'label');
        if (!label) {
            return '';
        }
        const mentionText = `@${label}`;
        const nextChar = (_a = input[offset + match.length]) !== null && _a !== void 0 ? _a : '';
        const shouldInsertSpace = nextChar.length > 0 && !nextChar.match(/\s/) && !nextChar.match(/[.,!?;:)\]}]/) && !nextChar.match(/[\"']/);
        return shouldInsertSpace ? mentionText + ' ' : mentionText;
    });
};
exports.replaceRteMentionShortcodes = replaceRteMentionShortcodes;
//# sourceMappingURL=rte-mentions.js.map